import * as React from "react";

import { ReactComponent as Logo } from "../assets/favicon64.svg";

import { Container, Header, Button, Icon } from "semantic-ui-react";
import PackageStatusContainer from "./PackageStatusContainer";
import PackageStatus from "../components/PackageStatus";

export default function AppHeader() {
  return (
    <Container>
      <Header
        as="h1"
        content="Object Accumulator"
        inverted
        style={{
          fontSize: "4em",
          fontWeight: "normal",
          marginBottom: 0,
          marginTop: "0.5em",
        }}
        image={<Logo style={{ margin: "0.1em" }} />}
      />
      <Header
        as="h3"
        content="A Javascript/Typescript object merging tool, focus on performance and easy-to-use. Good alternative to deepmerge in most case."
        inverted
        style={{
          fontSize: "1.7em",
          fontWeight: "normal",
          marginTop: "1.5em",
        }}
      />
      <Button
        basic
        inverted
        size="huge"
        onClick={() =>
          window.open("https://github.com/ivan114/ObjectAccumulator")
        }
      >
        <Icon name="github" />
        Github
      </Button>
      <Button
        basic
        inverted
        size="huge"
        onClick={() => {
          window.open("http://ivan114.github.io/ObjectAccumulator/docs");
        }}
      >
        <Icon name="book" />
        Docs
      </Button>
      <Button
        primary
        size="huge"
        onClick={() => {
          window.location.href = "#demo";
        }}
      >
        <Icon name="play" />
        Demo
      </Button>
      <PackageStatusContainer>
        <div style={{ width: "100%", padding: "0.5em" }}>
          Created with{" "}
          <span role="img" aria-label="heart">
            ❤️
          </span>{" "}
          by <a href="https://github.com/ivan114">Ivan Li</a>
        </div>
        <PackageStatus
          img="https://github.com/ivan114/ObjectAccumulator/workflows/Node%20CI/badge.svg"
          alt="NPM version"
        />
        <PackageStatus
          link="https://www.npmjs.com/package/object-accumulator"
          img="https://img.shields.io/npm/v/object-accumulator.svg"
          alt="NPM version"
        />
        <PackageStatus
          img="https://img.shields.io/npm/dm/object-accumulator.svg"
          alt="Downloads"
        />
        <PackageStatus
          link="https://github.com/conventional-changelog/standard-version"
          img="https://img.shields.io/badge/release-standard%20version-brightgreen.svg"
          alt="Standard Version"
        />
        <PackageStatus
          link="https://github.com/prettier/prettier"
          img="https://img.shields.io/badge/styled_with-prettier-ff69b4.svg"
          alt="styled with prettier"
        />
        <PackageStatus
          link="https://conventionalcommits.org"
          img="https://img.shields.io/badge/Conventional%20Commits-1.0.0-yellow.svg"
          alt="Conventional Commits"
        />
      </PackageStatusContainer>
    </Container>
  );
}
